'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const styles = require('./DetailsTitle.scss');
const CloseIcon = require('dibs-vg/dist/react/close');

function Title({ close, title }) {
    return (
        <div>
            <div className={classNames('rowFlex', 'colSm12', styles.wrapper)}>
                <span className={styles.text}>{title}</span>
                <a data-tn="close-modal" className={styles.closeWrapper} href="#0" onClick={close}>
                    <CloseIcon className={styles.close} />
                </a>
            </div>
            <div className={styles.headerBottomBorder}></div>
        </div>
    );
}

Title.propTypes = {
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired
};

module.exports = Title;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsTitle.jsx